import { mapTypeToCssClass } from './constants';
import { updateMarker } from './updateMarker';
import { initializePopup } from './initializePopup';
/**
 * Adds a marker to a Google Map instance with the specified options and callbacks.
 *
 * @param {object} options - The options for the marker.
 * @param {object} options.spot - The spot to add the marker for.
 * @param {object} options.maps - The Google Maps API object.
 * @param {object} options.map - The Google Map instance to add the marker to.
 * @param {Function} options.onClick - The callback to be called when the marker is clicked.
 * @returns {object} The Google Maps Marker instance.
 */
export const addMarker = ({ spot, maps, map, onClick: onClickCallback, onMouseEnter, onMouseLeave, onShowPopup, isMobile, isHighlighted, ratingFilters, }) => {
    const { spotId, latitude, longitude, title, markerLabelText, markerType, } = spot;
    const markerDiv = document.createElement('div');
    markerDiv.setAttribute('data-testid', `${spotId}-${encodeURIComponent(title)}`);
    markerDiv.setAttribute('data-price', markerLabelText);
    markerDiv.classList.add('SHMapPin');
    markerDiv.classList.add(mapTypeToCssClass[markerType]);
    markerDiv.textContent = markerLabelText;
    const position = new maps.LatLng(latitude, longitude);
    const marker = new maps.marker.AdvancedMarkerElement({
        position,
        map,
        content: markerDiv,
        title,
    });
    // update marker styles
    updateMarker({
        marker,
        spot,
        isMobile,
        map,
        ratingFilters,
    });
    marker.addListener('click', () => {
        if (isMobile) {
            onClickCallback(spot);
        }
        else {
            const popup = initializePopup({
                maps,
                map,
                position,
            });
            onShowPopup(popup);
            onClickCallback(spot);
        }
    });
    marker.content.addEventListener('mouseenter', () => {
        // Only call onMouseEnter if the marker is not already highlighted.
        if (!isHighlighted) {
            onMouseEnter(spotId);
        }
    });
    marker.content.addEventListener('mouseleave', () => {
        onMouseLeave();
    });
    return marker;
};
